export const chapters = [
  {
    name:
      '1. Ist es ansteckend, neben einer mit Sars-CoV-2 infizierten Person zu stehen?',
    id: 'q1',
    sort: 1,
    text: '1'
  },
  {
    name: '2. Welches ist der dominierende Übertragungsweg?',
    id: 'q2',
    sort: 2,
    text: '2'
  },
  {
    name: '3. Was ist der Unterschied von Aerosolen zur Tröpfcheninfektion?',
    id: 'q3',
    sort: 3,
    text: '3'
  },
  {
    name: '4. Was spricht gegen eine häufige Übertragung über Aerosole?',
    id: 'q4',
    sort: 4,
    text: '4'
  },
  {
    name: '5. Was spricht für eine häufige Übertragung über Aerosole?',
    id: 'q5',
    sort: 5,
    text: '5'
  },
  {
    name: '6. Wie lange bleiben Aerosole in der Luft?',
    id: 'q6',
    sort: 6,
    text: '6'
  },
  {
    name:
      '7. Wie wahrscheinlich ist es, sich mit solchen schwebenden virushaltigen Partikeln anzustecken?',
    id: 'q7',
    sort: 7,
    text: '7'
  },
  {
    name:
      '8. Kann ein einzelnes Virus einen Menschen krank machen? Wie viel braucht es?',
    id: 'q8',
    sort: 8,
    text: '8'
  },
  {
    name: '9. Kann ich mich auch draussen über Aerosole infizieren?',
    id: 'q9',
    sort: 9,
    text: '9'
  },
  {
    name: '10. Können auch Asymptomatische infektiöse Aerosole ausstossen?',
    id: 'q10',
    sort: 10,
    text: '10'
  },
  {
    name: '11. Wie kann man sich vor Aerosolen schützen?',
    id: 'q11',
    sort: 11,
    text: '11'
  },
  {
    name: '12. Wie lange überleben die Viren auf Oberflächen?',
    id: 'q12',
    sort: 12,
    text: '12'
  },
  {
    name: '13. Kann UV-Strahlung das Virus abtöten?',
    id: 'q13',
    sort: 13,
    text: '13'
  },
  {
    name: '14. Muss man Smartphones und Tablets ständig desinfizieren?',
    id: 'q14',
    sort: 14,
    text: '14'
  },
  {
    name: '15. Können Viren einen über die Haut infizieren?',
    id: 'q15',
    sort: 15,
    text: '15'
  },
  {
    name: '16. Ist es sicher, in einem Auto mit Mitinsassen zu fahren?',
    id: 'q16',
    sort: 16,
    text: '16'
  },
  {
    name: '17. Ist es sicher, mit dem Flugzeug zu reisen?',
    id: 'q17',
    sort: 17,
    text: '17'
  },
  {
    name: '18. Soll man den Aufzug benutzen?',
    id: 'q18',
    sort: 18,
    text: '18'
  },
  {
    name: '19. Was ist mit Toiletten?',
    id: 'q19',
    sort: 19,
    text: '19'
  }
]
